import { JSX } from 'react';
import { css } from '@bts-web/utils-style-engine';

interface SessionRowProps {
  icon: JSX.Element;
  label: string;
  timeRange: string | null;
  description: string;
  active: boolean;
}

const SessionRow = ({
  icon,
  label,
  timeRange,
  description,
  active,
}: SessionRowProps) => (
  <div
    className={css({
      display: 'flex',
      flexDirection: 'row',
      gap: 'small',
      paddingY: 'small',
      alignItems: 'flex-start',
    })}
  >
    <div className={css({ flexShrink: 0, paddingTop: 'extra_small_2' })}>
      {icon}
    </div>

    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        gap: 'extra_small_2',
        flex: 1,
      })}
    >
      <span
        className={css({
          fontSize: 'title.large_medium',
          fontWeight: 'title.large_medium',
          letterSpacing: 'title.large_medium',
          lineHeight: 'title.large_medium',
          color: active ? 'neutrals.text_primary' : 'neutrals.text_secondary',
        })}
      >
        {label}
      </span>

      {timeRange && (
        <span
          className={css({
            fontSize: 'caption.medium_medium',
            fontWeight: 'caption.medium_medium',
            letterSpacing: 'caption.medium_medium',
            lineHeight: 'caption.medium_medium',
            color: 'neutrals.text_secondary',
          })}
        >
          {timeRange}
        </span>
      )}

      <span
        className={css({
          fontSize: 'caption.small',
          fontWeight: 'caption.small',
          letterSpacing: 'caption.small',
          lineHeight: 'caption.small',
          color: active ? 'neutrals.text_primary' : 'neutrals.text_secondary',
        })}
      >
        {description}
      </span>
    </div>
  </div>
);

export { SessionRow, type SessionRowProps };
